import Styled from "styled-components";

export const Container = Styled.div`
`;

export const ContainerGrid = Styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: ${(props) => props.direction || "row"};
  grid-template-columns: 20px 75% 40px;
  margin-bottom: 10px;
`;

export const Label = Styled.h1`
`;
export const Space = Styled.div`
`;

export const EmptyCard = Styled.div`
`;

export const Trash = Styled.div`
`;

export const Radio = Styled.input`
`;
export const Link = Styled.div`
`;

export const GroupIcons = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TitleProduct = Styled.p`
`;

export const Box = Styled.div`
  @media (min-width: 1024px) {
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Center = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Line = Styled.div`
margin-top: 5px;
margin-bottom: 5px;
border: solid 1px #F0F2F5;
`;

export const AddressBox = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid ${(props) => (props.main ? props.theme.whitelabel?.theme?.text_primary_color : `${props.theme.whitelabel?.theme?.text_primary_color}66`)};
  padding: 4px 12px;
  border-radius: 10px;
  margin-bottom: 24px;
`;

export const DefaultAddressText = Styled.p`
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
  text-align: center;
`;
